<template>
 <div id="notification-list">
	<div class="notification-container"
		ref="notificationListContainer">
	 <notification-item
	 	v-for="(notification, index) in notifications"
		:key="index"
		:notification="notification"/>
		<div v-if="!notifications || notifications.length === 0" class="empty-section">{{this.$t('app.errors.no_notifications')}}</div>
		</div>
		<div class="form-group button-row">
			<div class="text-right">
					<base-button
						:title="$t('app.modal.cancel')"
						:classNames="`btn btn-default btn-outline rounded`"
						@clicked="cancel"
					/>
				</div>
			</div>
 </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Item from './NotificationListItem.vue';
import BaseButton from '@/components/shared/buttons/BaseButton';

export default {
  name: 'NotificationList',
  data() {
    return {
      isLoading: false,
      currentPageIndex: 1,
      notifications: undefined,
    };
  },
  components: {
    'notification-item': Item,
    'base-button': BaseButton,
  },
  props: {
    totalPages: {
      type: Number,
      required: true,
    },
  },
  methods: {
		 ...mapActions({
      fetchNotifications: 'users/fetchNotifications',
    }),
    cancel() {
      this.$emit('modalCanceled');
      this.$eventBus.hideModal();
    },
    handleScroll() {
      if (!this.$refs.notificationListContainer) {
        return;
      }
      if (this.$refs.notificationListContainer.scrollHeight - this.$refs.notificationListContainer.scrollTop <= this.$refs.notificationListContainer.offsetHeight * 1.1
      ) {
        this.loadNext();
        this.isLoading = true;
      } else {
        this.isLoading = false;
      }
    },
    loadNext() {
      if (this.totalPages === this.currentPageIndex) {
        return;
      }
      if (this.isLoading) {
        return;
      }
      this.currentPageIndex += 1;
      this.fetchNotifications({ id: this.loggedInUser.id, pageIndex: this.currentPageIndex }).then((response) => {
        this.notifications = this.notifications.concat(response.notifications);
      });
    },
  },
  created() {
    this.fetchNotifications({ id: this.loggedInUser.id, pageIndex: this.currentPageIndex }).then((response) => {
      this.notifications = response.notifications;
    });
  },
  mounted() {
    this.$refs.notificationListContainer.addEventListener('scroll', this.handleScroll);
  },
  computed: {
    ...mapGetters({
      loggedInUser: 'loggedInUser',
    }),
  },
};
</script>

<style lang="scss">
#notification-list {

	.button-row {
		padding: 20px;
	}

	.empty-section {
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    margin-top: 40px;
  }

	.notification-container {
		max-height: 500px;
    overflow-y: auto;
	}

}
</style>



// WEBPACK FOOTER //
// src/components/shared/notifications/NotificationList.vue